import React from 'react';
import { SquareSvgProps } from '@icons/icon.types';

function DeezerLogoIcon({ className, title, fillColor = '#A238FF', height, ...props }: SquareSvgProps) {
  return (
    <svg className={className} height={height} viewBox="0 0 717 199" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title}</title>
      <g>
        <path
          d="M5.8,36.5C2.6,36.5,0,46.8,0,59.6s2.6,23.2,5.8,23.2c3.2,0,5.8-10.4,5.8-23.2S9,36.5,5.8,36.5z"
          fill={fillColor}
        />
        <path
          d="M175.9,12.9c-3,0-5.7,6.7-7.6,17.3c-3-18.3-7.9-30.2-13.4-30.2c-6.6,0-12.2,16.8-14.9,41.3
                c-2.6-17.8-6.6-29.1-11.1-29.1c-6.3,0-11.6,22.3-13.6,53.4c-3.7-16-9.1-26-15-26c-5.9,0-11.3,10-15,26c-2-31.1-7.3-53.4-13.6-53.4
                c-4.5,0-8.5,11.3-11.1,29.1C58,16.8,52.3,0,45.8,0c-5.5,0-10.4,11.9-13.4,30.2c-1.9-10.6-4.6-17.3-7.6-17.3
                c-5.6,0-10.2,23.2-10.2,51.8s4.6,51.8,10.2,51.8c2.3,0,4.5-3.9,6.2-10.5c2.7,24.2,8.3,40.8,14.9,40.8c5.1,0,9.6-10,12.6-25.7
                c2.1,29.9,7.3,51.1,13.4,51.1c3.8,0,7.3-8.4,9.9-22.1c3.1,28.3,10.3,48.1,18.7,48.1c8.4,0,15.5-19.8,18.7-48.1
                c2.6,13.7,6.1,22.1,9.9,22.1c6.1,0,11.3-21.2,13.4-51.1c3,15.7,7.6,25.7,12.6,25.7c6.5,0,12.1-16.6,14.9-40.8
                c1.7,6.6,3.8,10.5,6.2,10.5c5.6,0,10.2-23.2,10.2-51.8S181.5,12.9,175.9,12.9L175.9,12.9z"
          fill={fillColor}
        />
        <path
          d="M194.9,36.5c-3.2,0-5.8,10.4-5.8,23.2s2.6,23.2,5.8,23.2c3.2,0,5.8-10.4,5.8-23.2S198.1,36.5,194.9,36.5z"
          fill={fillColor}
        />
      </g>
      <g>
        <path d="M341.6,128.2h65.2v-21.4h-34.5V97h32.4V79.5h-32.4v-9.2h34.5V48.9h-65.2V128.2z" />
        <path d="M414.2,128.2h65.2v-21.4H445V97h32.4V79.5H445v-9.2h34.5V48.9h-65.2V128.2z" />
        <path
          d="M716.3,128.2c-4.4-12.1-10.7-25-19-39.5c9.8-2.9,15.6-9,15.6-18.5c0-14.4-13.3-21.2-34.3-21.2h-43.2v79.2h30.9V95.4
                c6.9,11.6,11.9,22.5,15.2,32.8H716.3z M666.3,84.3v-14H677c4.5,0,7.1,2.5,7.1,7s-2.6,7-7.1,7H666.3z"
        />
        <path d="M562.7,128.2H628v-21.4h-34.5V97h32.4V79.5h-32.4v-9.2H628V48.9h-65.2V128.2z" />
        <path d="M486.9,70.3h31.9c-13.2,10.8-24.1,23.1-32.5,36.4v21.4h70.1v-21.4h-35c8-11.7,19.2-23.3,35-36.4V48.9h-69.5V70.3z" />
        <path
          d="M294.9,48.9h-39.7v79.2h39.7c24.6,0,42-16.4,42-39.6C336.9,65.3,319.5,48.9,294.9,48.9z M293.2,106.7H286V70.3h7.2
                c7.7,0,11.8,5.1,11.8,18.2C305.1,101.6,300.9,106.7,293.2,106.7z"
        />
      </g>
    </svg>
  );
}

export { DeezerLogoIcon };
